<template>
  <div id="judgesSuccess">
    <img src="../assets/img/success_title.png" alt="" class="title">
    <div class="qrcodes">
      <img src="../assets/img/qrcode.png" alt="" class="qrcode">
      <div class="smart">（扫一扫关注赛事咨询）</div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
export default {
  data () {
    return {}
  },
  mounted () {
    this.getShareConfig();
  },
  methods: {
    getShareConfig () {
      let link = this.isIos ? this.ios_first_url : location.href.split("#")[0];
      let that = this;
      this.axios.post('/Home/WeAuth/getConfig', {
        url: link
      })
        .then(({data}) => {
          if (data.code === 1) {
            wx.config({
              // debug: true,
              appId: data.data.appId,
              timestamp: data.data.timestamp,
              nonceStr: data.data.nonceStr,
              signature: data.data.signature,
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
            });
            wx.ready(function() {
              wx.checkJsApi({
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                success: function(res) {
                  let options = {
                    title: '新歌来啦官方通道', // 分享标题
                    desc: '为优秀的歌手提供卫星电视的播出平台，欢迎您的参与！', // 分享描述
                    link: location.origin + '/#/', // 分享链接
                    imgUrl: location.origin + '/logo.png', // 分享图标
                    success: function () {
                    // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                    // 用户取消分享后执行的回调函数
                    }
                  }
                  wx.onMenuShareTimeline(options);
                  wx.onMenuShareAppMessage(options);
                  wx.onMenuShareQQ(options);
                  wx.onMenuShareWeibo(options);
                  wx.onMenuShareQZone(options);
                }
              });
            });
          }
        });
    },
  }
}
</script>

<style lang="scss" scoped>
  #judgesSuccess{
    background: url('../assets/img/bg.png') no-repeat 0 0 / 100% 2000px;
    padding: 330px 150px 0;
    text-align: center;
    .title{
      width:450px;
      height:330px;
    }
    .qrcodes{
      margin-top:100px;
      text-align: center;
      .qrcode{
        width:168px;
        height:168px;
        pointer-events: auto;
      }
      .smart{
        font-size:18px;
        color:#fff;
        letter-spacing: 5px;
        margin-top:20px;
      }
    }
  }
</style>